import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/informes-sobre-extractables-y-lixiviables")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/informes-sobre-extractables-y-lixiviables", statusCode: 301 }); },
});
